import React from "react";
import Headline from "./Headline";
import HomeLink from "../../widgets/HomeLink";

const bannerPath = '/iceholidays-assets/images/mice-banner.png';
const breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'GD VOUCHER' }
] 
const miceLogoPath = '/iceholidays-assets/images/mice-logo-new.png';

const TourVoucherPage = () => (

  <div className="mice-page">
    <Headline showSearch={false} bannerImage={bannerPath} breadcrumbs={breadcrumbs}>
      <span className="title">
        <img src={miceLogoPath} alt="MICE Logo"/>
      </span>
    </Headline>

    <div className="mice-page_body mice-page_body-about">
      <div id="header">
        <h1>GD VOUCHER</h1>
      </div>
      <div id="article">
        <p><strong>Giving Every Gift Greater Value and Anticipation</strong><br/>
        The GD Voucher is a travel gift voucher thoughtfully created by Golden Destinations (GD). More than just a voucher with cash value, it is a key that opens the door to discovering the world.</p>

        <p>Voucher holders can use the GD Voucher flexibly to purchase or offset selected travel packages and designated travel services offered by Golden Destinations. It gives recipients the freedom to choose, allowing every gift to better match their personal preferences.</p>

        <p><strong>Why Choose GD Voucher?</strong></p>

        <p><strong>Brand Assurance</strong><br/>
        Backed by the trusted quality of Golden Destinations, making your gift more presentable and meaningful.</p>

        <p><strong>Ultimate Flexibility</strong><br/>
        Applicable to a wide range of travel products, breaking away from the limitations of conventional gifts.</p>

        <p><strong>Custom Validity Options</strong><br/>
        Available in 3-month, 6-month, and 12-month validity periods, making it suitable for different campaign timelines and gifting needs.</p>

        <p><strong>Fast Issuance</strong><br/>
        An efficient and convenient process. Vouchers are issued upon full payment, ensuring smooth coordination for your event or gifting arrangements.</p>

        <p><strong>Multiple Usage Scenarios</strong><br/>
        “One voucher, endless possibilities.”<br/>
        GD Voucher is an ideal gifting solution for both corporate and personal occasions.</p>

        <table>
          <thead>
              <tr>
                  <th>Category</th>
                  <th>Suggested Usage</th>
              </tr>
          </thead>
          <tbody>
              <tr>
                  <td>Corporate Incentives</td>
                  <td>Outstanding employee rewards, annual performance recognition, long-service awards</td>
              </tr>
              <tr>
                  <td>Business Relations</td>
                  <td>Customer appreciation gifts, corporate souvenirs and partner recognition gifts.</td>
              </tr>
              <tr>
                  <td>Brand Marketing</td>
                  <td>Festive gifts, promotional giveaways, lucky draw grand prizes</td>
              </tr>
              <tr>
                  <td>Personal Gifting</td>
                  <td>Birthdays, wedding gifts, appreciation gifts, special commemorations</td>
              </tr>
          </tbody>
        </table>
      </div> 
    </div>
  </div>
);

export default TourVoucherPage;